import React from 'react';
import { useForm } from 'react-hook-form';
import { withRouter } from 'react-router-dom';
import { useStateMachine } from 'little-state-machine';
import { compose } from 'redux';
import { connect } from 'react-redux';
import updateAction from './updateAction';
import Loader from '../../utils/Loader';
import Card from 'react-bootstrap/Card';

const Step3 = ({ history, phone }) => {
	const { register, handleSubmit, watch, errors } = useForm();
	const revealWhatsapp = watch('receiveWhatsappNotification');
	const { state, action } = useStateMachine(updateAction);

	const onSubmit = (data) => {
		action(data);
		history.push('./step4');
	};

	Loader.hide();
	return (
		<Card>
			<Card.Header className="setup-content" id="step-3">
				<h3>Do you wish to receive updates on WhatsApp?</h3>
			</Card.Header>
			<Card.Body>
				<form onSubmit={handleSubmit(onSubmit)}>
					<p>
						We will only be sending course and score updates. We will not be sending
						any promotional material
					</p>
					<div className="funkyradio">
						{/* <span className="profileError">
							{errors.receiveWhatsappNotification?.type === 'required' &&
								'Whatsapp Notification is required'}
						</span> */}
						<div className="funkyradio-success">
							<input
								type="radio"
								name="receiveWhatsappNotification"
								id="radio1tt"
								ref={register({
									required: true,
								})}
								value={1}
								defaultChecked={state.data?.receiveWhatsappNotification === '1'}
							/>
							<label for="radio1tt">Yes</label>
						</div>
						<div className="funkyradio-success">
							<input
								type="radio"
								name="receiveWhatsappNotification"
								value={0}
								defaultChecked={state.data?.receiveWhatsappNotification === '0'}
								ref={register({
									required: true,
								})}
								id="radio2tt"
							/>
							<label for="radio2tt">No</label>
						</div>
					</div>

					{revealWhatsapp === '1' ||
					(typeof revealWhatsapp === 'undefined' &&
						state.data?.receiveWhatsappNotification === '1') ? (
						<div className="form-group" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="whatsappNumber">
								WhatsApp Number
							</label>
							<input
								type="text"
								className="form-control"
								name="whatsappNumber"
								ref={register({
									required: true,
									pattern: /^[6789]\d{9}$/,
								})}
								defaultValue={state.data?.whatsappNumber || phone}
							/>

							<span className="profileError">
								{errors.whatsappNumber?.type === 'pattern' && 'Incorrect mobile number'}
							</span>
							<span className="profileError">
								{errors.whatsappNumber?.type === 'required' &&
									'Whatsapp number required'}
							</span>
						</div>
					) : null}

					<button
						aria-label="next"
						className="btn btn-primary nextBtn pull-right"
						type="submit"
					>
						Next
					</button>
				</form>
			</Card.Body>
		</Card>
	);
};

const mapStateToProps = (state) => {
	const { phone } = state.rootReducer.userDetails;
	return {
		phone,
	};
};

export default compose(withRouter, connect(mapStateToProps))(Step3);
